import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const formatDateTime = (date) => {
  return new Date(date).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const parseReviewerList = (list = []) => {
  return list?.map((item) => item?.value?.name).filter(Boolean);
};

export const toApprovalsRows = (arr, usersMap = {}) =>
  arr?.map((item, i) => {
    const sub = typeof item === 'string' ? item : item.sub;
    const name = typeof item === 'string' ? item : item.name;
    const user = usersMap[sub];
    const designation = user?.designation || '';
    return {
      id: Date.now() + i,
      order: i,
      value: { sub, name, designation },
    };
  });
